// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.task-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
  width: 100%;
  align-items: flex-start;
}

.task-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.task-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}
.task-header .task-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.task-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.3rem;
  font-weight: 600;
}

.task-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.task-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.task-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.task-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 0.8rem;
}

.view-task-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.view-task-detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.view-task-detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-task-detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}
.view-task-detail-item a {
  color: var(--primary-color);
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: underline;
}
.view-task-detail-item a:hover {
  text-decoration: none;
}
.view-task-detail-item.status-logs-section {
  grid-column: 1/-1;
}
.view-task-detail-item.status-logs-section > div {
  width: 100%;
}
.view-task-detail-item.task-status-history {
  margin-top: 1rem;
}

.task-description p {
  font-weight: 400 !important;
  line-height: 1.4rem !important;
}

.status-logs {
  margin-top: 1rem;
  position: relative;
}
.status-logs::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, var(--primary-color), var(--primary-light));
  z-index: 1;
}

.status-log-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  padding-left: 0.5rem;
}
.status-log-item:last-child {
  margin-bottom: 0;
}

.status-log-icon {
  position: relative;
  z-index: 2;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-right: 0.5rem;
  flex-shrink: 0;
}
.status-log-icon .icon {
  font-size: 1rem;
}
.status-log-icon .icon.success {
  color: var(--success-color);
}
.status-log-icon .icon.danger {
  color: var(--danger-color);
}

.status-log-content {
  flex: 1 1;
  background-color: var(--bg-light);
  border-radius: 8px;
  padding: 1rem;
  border-left: 3px solid transparent;
  transition: var(--transition);
}
.status-log-content:hover {
  background-color: #f1f5f9;
}

.status-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.status-badge.completed {
  background-color: rgba(16, 185, 129, 0.15);
  color: var(--success-color);
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.status-badge.incomplete {
  background-color: rgba(239, 68, 68, 0.15);
  color: var(--danger-color);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.status-log-date {
  color: var(--text-medium);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}

.status-log-user {
  color: var(--text-medium);
  font-size: 0.85rem;
  font-style: italic;
  margin-top: 0.25rem;
}

.status-logs p {
  text-align: center;
  color: var(--text-light);
  font-style: italic;
  padding: 2rem;
  background-color: var(--bg-light);
  border-radius: 8px;
  border: 2px dashed #e5e7eb;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .task-detail-container {
    padding: 1rem;
  }
  .task-card {
    padding: 1.5rem;
  }
  .task-details-grid {
    grid-template-columns: 1fr;
  }
  .status-log-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .status-log-date {
    white-space: normal;
  }
  .status-logs::before {
    left: 0.75rem;
  }
  .status-log-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.75rem;
  }
  .status-log-icon .icon {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewTask/ViewTask.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAEJ;;AACE;EACA,aAAA;EACA,YAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAEJ;AAAI;EACE,yCAAA;EACA,2BAAA;AAEN;AAAM;EACE,YAAA;EACA,2BAAA;AAER;AAEI;EACE,wCAAA;EACA,0BAAA;AAAN;AAEM;EACE,YAAA;EACA,2BAAA;AAAR;;AAMA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAHF;;AAOE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAOE;EACE,yCAAA;EACA,2BAAA;AALJ;AAQE;EACE,wCAAA;EACA,0BAAA;AANJ;;AAUA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAPF;AASE;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AARJ;AAWE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AATJ;AAYE;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAVJ;AAYI;EACE,qBAAA;AAVN;AAeE;EACE,iBAAA;AAbJ;AAeI;EACE,WAAA;AAbN;AAgBE;EACE,gBAAA;AAdJ;;AAmBE;EACE,2BAAA;EACA,8BAAA;AAhBJ;;AAqBA;EACE,gBAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,kFAAA;EACA,UAAA;AAlBJ;;AAsBA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AAnBF;AAqBE;EACE,gBAAA;AAnBJ;;AAuBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,oBAAA;EACA,cAAA;AApBF;AAsBE;EACE,eAAA;AApBJ;AAsBI;EACE,2BAAA;AApBN;AAuBI;EACE,0BAAA;AArBN;;AA0BA;EACE,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,6BAAA;AAvBF;AAyBE;EACE,yBAAA;AAvBJ;;AA4BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AAzBF;;AA4BA;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAzBF;AA2BE;EACE,0CAAA;EACA,2BAAA;EACA,yCAAA;AAzBJ;AA4BE;EACE,yCAAA;EACA,0BAAA;EACA,wCAAA;AA1BJ;;AA8BA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA3BF;;AAoCA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,0BAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AAjCF;;AAoCA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE;IACE,yBAAA;EAjCF;AACF;AAoCA;EACE;IACE,aAAA;EAlCF;EAqCA;IACE,eAAA;EAnCF;EAsCA;IACE,0BAAA;EApCF;EAuCA;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EArCF;EAwCA;IACE,mBAAA;EAtCF;EA0CE;IACE,aAAA;EAxCJ;EA4CA;IACE,aAAA;IACA,cAAA;IACA,qBAAA;EA1CF;EA4CE;IACE,mBAAA;EA1CJ;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.task-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: flex-start;\r\n}\r\n\r\n.task-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.task-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 1px solid #eee;\r\n  .task-header-data {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n  }\r\n}\r\n  .client-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  \r\n  button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n    \r\n    &.btn-update {\r\n      background-color: var(--primary-light-bg);\r\n      color: var(--primary-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n    \r\n    &.btn-delete {\r\n      background-color: var(--danger-light-bg);\r\n      color: var(--danger-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.task-title {\r\n  h2 {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n.task-status {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  margin-top: 0.5rem;\r\n\r\n  &.active {\r\n    background-color: rgba(16, 185, 129, 0.1);\r\n    color: var(--success-color);\r\n  }\r\n\r\n  &.inactive {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: var(--danger-color);\r\n  }\r\n}\r\n\r\n.task-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 0.8rem;\r\n}\r\n\r\n.view-task-detail-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    color: var(--primary-color);\r\n    font-size: 1.25rem;\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    color: var(--text-light);\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    color: var(--text-dark);\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n  }\r\n\r\n  a {\r\n    color: var(--primary-color);\r\n    font-weight: 500;\r\n    font-size: 0.95rem;\r\n    text-decoration: underline;\r\n\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  // Special styling for status logs section\r\n  &.status-logs-section {\r\n    grid-column: 1 / -1; // Span full width\r\n    \r\n    > div {\r\n      width: 100%;\r\n    }\r\n  }\r\n  &.task-status-history{\r\n    margin-top: 1rem;\r\n  }\r\n}\r\n\r\n.task-description{\r\n  p{\r\n    font-weight: 400 !important;\r\n    line-height: 1.4rem !important;\r\n  }\r\n}\r\n\r\n// Status Logs Styling\r\n.status-logs {\r\n  margin-top: 1rem;\r\n  position: relative;\r\n  \r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 1rem;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 2px;\r\n    background: linear-gradient(to bottom, var(--primary-color), var(--primary-light));\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.status-log-item {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin-bottom: 1.5rem;\r\n  padding-left: 0.5rem;\r\n  \r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.status-log-icon {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border-radius: 50%;\r\n  background-color: var(--card-bg);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  margin-right: 0.5rem;\r\n  flex-shrink: 0;\r\n\r\n  .icon {\r\n    font-size: 1rem;\r\n    \r\n    &.success {\r\n      color: var(--success-color);\r\n    }\r\n    \r\n    &.danger {\r\n      color: var(--danger-color);\r\n    }\r\n  }\r\n}\r\n\r\n.status-log-content {\r\n  flex: 1;\r\n  background-color: var(--bg-light);\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  border-left: 3px solid transparent;\r\n  transition: var(--transition);\r\n  \r\n  &:hover {\r\n    background-color: #f1f5f9;\r\n    // border-left-color: var(--primary-color);\r\n  }\r\n}\r\n\r\n.status-log-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.status-badge {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  \r\n  &.completed {\r\n    background-color: rgba(16, 185, 129, 0.15);\r\n    color: var(--success-color);\r\n    border: 1px solid rgba(16, 185, 129, 0.3);\r\n  }\r\n  \r\n  &.incomplete {\r\n    background-color: rgba(239, 68, 68, 0.15);\r\n    color: var(--danger-color);\r\n    border: 1px solid rgba(239, 68, 68, 0.3);\r\n  }\r\n}\r\n\r\n.status-log-date {\r\n  color: var(--text-medium);\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.status-log-user {\r\n  color: var(--text-medium);\r\n  font-size: 0.85rem;\r\n  font-style: italic;\r\n  margin-top: 0.25rem;\r\n  \r\n  // &::before {\r\n  //   content: '👤 ';\r\n  //   margin-right: 0.25rem;\r\n  // }\r\n}\r\n\r\n// Empty state for status logs\r\n.status-logs p {\r\n  text-align: center;\r\n  color: var(--text-light);\r\n  font-style: italic;\r\n  padding: 2rem;\r\n  background-color: var(--bg-light);\r\n  border-radius: 8px;\r\n  border: 2px dashed #e5e7eb;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.error-message {\r\n  color: var(--danger-color);\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .task-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .task-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .task-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .status-log-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .status-log-date {\r\n    white-space: normal;\r\n  }\r\n  \r\n  .status-logs {\r\n    &::before {\r\n      left: 0.75rem;\r\n    }\r\n  }\r\n  \r\n  .status-log-icon {\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    margin-right: 0.75rem;\r\n    \r\n    .icon {\r\n      font-size: 0.875rem;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
